import { Body } from './modal.styles';

export default Body;
